var rich_content_viewer_default = {
  "fontElementMap": "OPlAe",
  "wrapper": "o-kbe",
  "pluginContainerMobile": "_0-5v6",
  "viewer": "bYILO",
  "android": "LERmJ",
  "rootedTraversedContent": "jBi9-",
  "atomic": "U1aRG",
  "toolbar": "uBiDz",
  "block": "wVVdd"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
